/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterBase.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterBase>): ScheduleExecutionParameterBase {
        let obj = Object.assign(new ScheduleExecutionParameterBase(), model);
        ScheduleExecutionParameterBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterBase>): ScheduleExecutionParameterBase {
        if (!model) return null;
        return ScheduleExecutionParameterBase.newInstance(<ScheduleExecutionParameterBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterBase) {
        if (!obj) return;

        models.ScheduleExecutionParameterBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterBase): boolean {
        switch (obj.type)
        {
            case "ScheduleExecutionParameterForAiAgentArtifact":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForAiAgentArtifact.prototype);
                break;
            case "ScheduleExecutionParameterForAssessmentAgentAgenticFeed":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForAssessmentAgentAgenticFeed.prototype);
                break;
            case "ScheduleExecutionParameterForAssessmentRunReport":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForAssessmentRunReport.prototype);
                break;
            case "ScheduleExecutionParameterForComplianceStandard":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForComplianceStandard.prototype);
                break;
            case "ScheduleExecutionParameterForExecutiveDashboardReport":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForExecutiveDashboardReport.prototype);
                break;
            case "ScheduleExecutionParameterForNextGenReport":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForNextGenReport.prototype);
                break;
            case "ScheduleExecutionParameterForPolicy":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForPolicy.prototype);
                break;
            case "ScheduleExecutionParameterForPolicyRemediation":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForPolicyRemediation.prototype);
                break;
            case "ScheduleExecutionParameterForTemplateAwsProvider":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForTemplateAwsProvider.prototype);
                break;
            case "ScheduleExecutionParameterForTemplateAzureProvider":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForTemplateAzureProvider.prototype);
                break;
            case "ScheduleExecutionParameterForTemplateBase":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForTemplateBase.prototype);
                break;
            case "ScheduleExecutionParameterForTemplateGcpProvider":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForTemplateGcpProvider.prototype);
                break;
            case "ScheduleExecutionParameterForTemplateOciProvider":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterForTemplateOciProvider.prototype);
                break;
            case "ScheduleExecutionParameterServiceAccountBase":
                Object.setPrototypeOf(obj, models.ScheduleExecutionParameterServiceAccountBase.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ScheduleExecutionParameterBase)[] {
        return [
            models.ScheduleExecutionParameterForAiAgentArtifact,
            models.ScheduleExecutionParameterForAssessmentAgentAgenticFeed,
            models.ScheduleExecutionParameterForAssessmentRunReport,
            models.ScheduleExecutionParameterForComplianceStandard,
            models.ScheduleExecutionParameterForExecutiveDashboardReport,
            models.ScheduleExecutionParameterForNextGenReport,
            models.ScheduleExecutionParameterForPolicy,
            models.ScheduleExecutionParameterForPolicyRemediation,
            models.ScheduleExecutionParameterForTemplateAwsProvider,
            models.ScheduleExecutionParameterForTemplateAzureProvider,
            models.ScheduleExecutionParameterForTemplateBase,
            models.ScheduleExecutionParameterForTemplateGcpProvider,
            models.ScheduleExecutionParameterForTemplateOciProvider,
            models.ScheduleExecutionParameterServiceAccountBase,
        ];
    }

    fixupFields() {
    }

}
